<template>
    <div class="slider">
        <swiper-wrapper class="items" :options="options">
            <template #slides>
                <div
                    v-for="(slide, index) in slides"
                    :key="`slide_${index}`"
                    class="swiper-slide"
                >
                    <div class="image" ref="fit">
                        <visual :src="image(slide)" />
                    </div>
                </div>
            </template>
        </swiper-wrapper>
    </div>
</template>

<script>
import 'swiper/swiper-bundle.css'

import Visual from 'gvue/src/core/Visual'
import SwiperWrapper from '@/components/common/SwiperWrapper'

import getImage from '@/helpers/image'
import objectFit from '@/mixins/fit'

export default {
    name: 'EditionSlider',
    mixins: [objectFit],
    components: {
        Visual,
        SwiperWrapper
    },
    props: {
        slides: { type: Array, required: true }
    },
    computed: {
        isSingle() {
            return this.slides.length === 1
        },
        options() {
            const tools = {
                simulateTouch: true,
                navigation: {},
                pagination: {
                    clickable: true
                }
            }
            return {
                slidesPerView: 1,
                simulateTouch: false,
                ...(!this.isSingle && tools)
            }
        }
    },
    methods: {
        image(name) {
            return getImage({ type: 'visual', name, ext: 'jpg' })
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.slider
    position: relative

    .image
        position: relative
        padding-top: 100%

        img
            display: block
            position: absolute
            top: 0
            left: 0
            height: 100%
            width: 100%
            object-fit: cover

+mobile
    .slider
        margin: ($gap * -2.5) 0
        z-index: -1

    .g
        .g_restrict
            padding: 0

+desktop
    .swiper-container
        max-width: calc(66.25em * 0.45)
</style>
